export default __webpack_public_path__ + "static/media/Mechanical Clock Ring.c3eccb3f.mp3";